import React from 'react';
import {
  ProfileCard,
  CardTitle,
  CardContent,
  TagCloud,
  Tag
} from './styles';

const StrengthsSection = () => {
  return (
    <ProfileCard>
      <CardTitle>Fortalezas Políticas</CardTitle>
      <CardContent>
        <TagCloud>
          <Tag>Perfil empresarial</Tag>
          <Tag>Recursos económicos</Tag>
          <Tag>Pragmatismo político</Tag>
          <Tag>Alianzas estratégicas</Tag>
          <Tag>Mensaje híbrido</Tag>
          <Tag>Actor económico clave</Tag>
        </TagCloud>
      </CardContent>
    </ProfileCard>
  );
};

export default StrengthsSection;
